(function () {
  'use strict';

  if (window.sgFbtPosition) return;
  window.sgFbtPosition = true;

  function positionWidget() {
    var content = document.getElementById('MainContent');
    if (!content) return;

    var reviews = content.querySelector('#looxReviews');
    var widget = content.querySelector('.cbb-frequently-bought-container.cbb-product-page-view');
    var reviewsSection = reviews && reviews.closest('.shopify-section');
    if (!reviewsSection || !widget) return;

    var container = content.querySelector('[data-sg-fbt-position]');
    if (!container) {
      container = document.createElement('div');
      container.className = 'page-width';
      container.setAttribute('data-sg-fbt-position', '');
    }

    if (reviewsSection.nextElementSibling !== container) reviewsSection.after(container);
    if (widget.parentElement !== container) container.appendChild(widget);
  }

  document.addEventListener('codeblackbelt:frequently-bought-together:rendered', positionWidget);
  document.addEventListener('shopify:section:load', positionWidget);
  document.addEventListener('shopify:section:reorder', positionWidget);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionWidget, { once: true });
  } else {
    positionWidget();
  }
})();
